import { useContext, useCallback, useMemo } from 'external/react'

import { authService } from 'services/auth.service';

import Auth, {initialModals} from 'context/auth-context'

import getName from 'utilities/enum'

export default function useAuth() {

	const {state, update} = useContext(Auth.Context);
    const {user, modals} = state

	const handleClose = useCallback(() => {
		const modalUpdates = Object.entries(initialModals).reduce((modalUpdates, [modal, initial]) => {
			modalUpdates[modal] = getValueUpdates(initial)
			return modalUpdates
		}, {}) 
        update({modals: modalUpdates})
	}, [update])

	const updateModal = useCallback((modal, open, values) => {
		const valueUpdates = getValueUpdates(values)
		update({modals: {[modal]: {open: {$set: open}, ...valueUpdates}}})
	}, [update])
	

	function showReset( ) {
		update({modals: {
			login: getValueUpdates(initialModals.login),
			register: getValueUpdates(initialModals.register),
			reset: {open: {$set: true}, email: {$set: modals.login.email}}
		}})
	}


	function showRegister( ) {
		update({modals: {
			register: getValueUpdates({...initialModals.register, open: true}),
			login: getValueUpdates(initialModals.login),
			reset: getValueUpdates(initialModals.reset)
		}})
	}

	function showLogin( ) {
		update({modals: {
			login: getValueUpdates({...initialModals.login, open: true}),
			register: getValueUpdates(initialModals.register),
			reset: getValueUpdates(initialModals.reset)
		}})
	}

	async function login(user) {
		const response = await authService.login({...user});
		const { data, status, message } = response.data
		if (status) {
			throw new Error(message)
		} else {
            update({user: {$set: data}})
			localStorage.setItem('user', JSON.stringify(data));
			return data
		}
	}


	function logout () {
        update({user: {$set: undefined}})
        localStorage.removeItem('user')
		window.location.replace('/')
	}

	const role = useMemo(() => user && getName('role', user.role), [user])

	const modalsOpen = useMemo(() => modals.login.open || modals.reset.open || modals.register.open, [modals.login.open, modals.reset.open, modals.register.open])

    return {
        user,
		role,
		modalsOpen,
		modals,
		handleClose,
		showReset,
		showRegister,
		showLogin,
		updateModal,
		login,
		logout,
        state,
        update
    }
}

function getValueUpdates (values = {}) {
	return Object.entries(values).reduce((updates, [prop, value]) => {
		updates[prop] = {$set: value}
		return updates
	}, {}) 
}

